module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/173.25470e4b.png";